// extracted by mini-css-extract-plugin
module.exports = {"Table":"PreviewSensorDataModal_Table__7C3qZ","KendoGrid":"PreviewSensorDataModal_KendoGrid__2L39i"};